<template>

    <div class="hit-row">
      <div class="hit-col-md-6 hit-col-md-hit-offset-3">
        <div class="hit-panel hit-panel-primary">
          <div class="hit-panel-heading">

            Login auf HitorShit

          </div>

          <div class="hit-panel-body">

            <loginForm :settings="{onSubmit: function(data){ onSubmit(data); }}"/>

        </div>
      </div>
    </div>
  </div>

</template>

<script>

import loginForm from '@core/components/content/login_form'

export default{

  props: {callback: Function},

  components: {loginForm},

  methods: {

    onSubmit (data) {
      this.$hit_post({ url: 'hitclick/hitorshit/get',
        data: {user: data.username, password: data.password},
        callback: function (ret) {
          if (ret.data[0]) { this.callback(ret.data[1]) }
        }.bind(this) })
    }
  }

}
</script>
